import { render, staticRenderFns } from "./cropper.vue?vue&type=template&id=c96621a8&scoped=true&"
import script from "./cropper.vue?vue&type=script&lang=js&"
export * from "./cropper.vue?vue&type=script&lang=js&"
import style0 from "./cropper.vue?vue&type=style&index=0&id=c96621a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c96621a8",
  null
  
)

export default component.exports